import { getCommunityInformationRuntimeConfig } from "../localFirebaseSafety";
import firebaseClientDefaults from "../firebaseClientDefaults.json";

export const COMMUNITY_INFORMATION_MOCK_PROVIDER_LABEL =
  "Mock provider — synthetic data only";
export const COMMUNITY_INFORMATION_OPENAI_PROVIDER_LABEL =
  "OpenAI provider — production";

export function isCommunityInformationAgentEnabled(value) {
  return String(value ?? "").trim().toLowerCase() === "true";
}

export function resolveCommunityInformationConfig(env = process.env) {
  return getCommunityInformationRuntimeConfig(env, {
    apiKey: env.REACT_APP_FIREBASE_API_KEY || firebaseClientDefaults.apiKey,
    authDomain:
      env.REACT_APP_FIREBASE_AUTH_DOMAIN || firebaseClientDefaults.authDomain,
    projectId:
      env.REACT_APP_FIREBASE_PROJECT_ID || firebaseClientDefaults.projectId,
    storageBucket:
      env.REACT_APP_FIREBASE_STORAGE_BUCKET || firebaseClientDefaults.storageBucket,
    messagingSenderId:
      env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ||
      firebaseClientDefaults.messagingSenderId,
    appId: env.REACT_APP_FIREBASE_APP_ID || firebaseClientDefaults.appId,
  });
}

const runtimeConfig = resolveCommunityInformationConfig();

export const COMMUNITY_INFORMATION_AGENT_ENABLED = runtimeConfig.enabled;
export const COMMUNITY_INFORMATION_PROVIDER_MODE = runtimeConfig.providerMode;
export const COMMUNITY_INFORMATION_PROVIDER_LABEL = runtimeConfig.providerLabel;
export const COMMUNITY_INFORMATION_RUNTIME = runtimeConfig.runtime;
